/* eslint-disable max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { USER_ROLES as ROLES } from 'constants'

export const DIALOG_CHANGE_ROLE_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.change_role.title"
        defaultMessage="Изменение должности"
    />
)

export const DIALOG_CHANGE_ROLE_SUBMIT_BUTTON_CAPTION = (
    <FormattedMessage
        id="members_control_block.dialog.change_role.submit_button.caption"
        defaultMessage="Изменить"
    />
)

export const DIALOG_CHANGE_ROLE_MEMBER_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.change_role.member.title"
        defaultMessage="Изменить должность игроку:"
    />
)

export const DIALOG_CHANGE_ROLE_MEMBERS_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.change_role.members.title"
        defaultMessage="Изменить должность игроков:"
    />
)

export const DIALOG_CHANGE_ROLE_NEW_ROLE_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.change_role.new_role.title"
        defaultMessage="Новая должность:"
    />
)

const CONTROL_LOWER_ROLES = (
    <FormattedMessage
        id='roles_permissions.control_lower_roles'
        defaultMessage='управление личным составом ниже по рангу (кроме Офицера снабжения);'
    />
)
const ADD_NEW_PLAYERS = (
    <FormattedMessage
        id='roles_permissions.add_new_players'
        defaultMessage='набор игроков в клан;'
    />
)
const ACTIVATE_RESERVES = (
    <FormattedMessage
        id='roles_permissions.activate_reserves'
        defaultMessage='активация резервов;'
    />
)
const PREPARE_RESERVES = (
    <FormattedMessage
        id='roles_permissions.prepare_reserves'
        defaultMessage='подготовка резервов;'
    />
)
const GLOBAL_MAP = (
    <FormattedMessage
        id='roles_permissions.global_map'
        defaultMessage='управление кланом на Глобальной карте.'
    />
)
const VIEW_GLOBAL_MAP = (
    <FormattedMessage
        id='roles_permissions.view_global_map'
        defaultMessage='просмотр тактической информации о клане на Глобальной карте.'
    />
)
const VIEW_TREASURY = (
    <FormattedMessage
        id='roles_permissions.view_treasury'
        defaultMessage='просмотр казны клана;'
    />
)
const RECIEVE_RESERVE_BONUS = (
    <FormattedMessage
        id='roles_permissions.recieve_reserve_bonus'
        defaultMessage='получение надбавки от клановых резервов;'
    />
)

export const USER_ROLES_DESCRIPTIONS = {
    [ROLES.COMMANDER]: (
        <FormattedMessage
            id='roles_descriptions.commander'
            defaultMessage='Глава клана. Обладает всеми правами управления кланом и всем его имуществом, а также личным составом.'
        />
    ),
    [ROLES.EXECUTIVE_OFFICER]: (
        <FormattedMessage
            id='roles_descriptions.executive_officer'
            defaultMessage='Первый помощник командующего. Обладает основными полномочиями командующего, управляет личным составом ниже по рангу.'
        />
    ),
    [ROLES.PERSONNEL_OFFICER]: (
        <div>
            <p>
                <FormattedMessage
                    id='roles_descriptions.personnel_officer'
                    defaultMessage='Помощник командующего со следующими полномочиями:'
                />
            </p>
            <ul>
                <li>{CONTROL_LOWER_ROLES}</li>
                <li>{ADD_NEW_PLAYERS}</li>
                <li>{PREPARE_RESERVES}</li>
                <li>{ACTIVATE_RESERVES}</li>
                <li>{GLOBAL_MAP}</li>
            </ul>
        </div>
    ),
    [ROLES.COMBAT_OFFICER]: (
        <div>
            <p>
                <FormattedMessage
                    id='roles_descriptions.combat_officer'
                    defaultMessage='Командир на поле боя. Обладает следующими полномочиями:'
                />
            </p>
            <ul>
                <li>{CONTROL_LOWER_ROLES}</li>
                <li>{ACTIVATE_RESERVES}</li>
                <li>{GLOBAL_MAP}</li>
            </ul>
        </div>
    ),
    [ROLES.INTELLIGENCE_OFFICER]: (
        <FormattedMessage
            id='roles_descriptions.intelligence_officer'
            defaultMessage='Боец, заслуживший признания клана и удостоенный офицерского звания.'
        />
    ),
    [ROLES.QUARTERMASTER]: (
        <FormattedMessage
            id='roles_descriptions.quartermaster'
            defaultMessage='Офицер клана с полномочиями распределения казны клана.'
        />
    ),
    [ROLES.RECRUITMENT_OFFICER]: (
        <FormattedMessage
            id='roles_descriptions.recruitment_officer'
            defaultMessage='Офицер клана, ответственный за набор игроков в клан.'
        />
    ),
    [ROLES.JUNIOR_OFFICER]: (
        <FormattedMessage
            id='roles_descriptions.junior_officer'
            defaultMessage='Боец, заслуживший почтение соклановцев.'
        />
    ),
    [ROLES.PRIVATE]: (
        <FormattedMessage
            id='roles_descriptions.private'
            defaultMessage='Игрок клана без особых полномочий, но и без ограничений.'
        />
    ),
    [ROLES.RECRUIT]: (
        <div>
            <p>
                <FormattedMessage
                    id='roles_descriptions.recruit'
                    defaultMessage='Игрок клана без следующих прав:'
                />
            </p>
            <ul>
                <li>{VIEW_TREASURY}</li>
                <li>{VIEW_GLOBAL_MAP}</li>
            </ul>
        </div>
    ),
    [ROLES.RESERVIST]: (
        <div>
            <p>
                <FormattedMessage
                    id='roles_descriptions.reservist'
                    defaultMessage='Игрок клана без следующих прав:'
                />
            </p>
            <ul>
                <li>{RECIEVE_RESERVE_BONUS}</li>
                <li>{VIEW_TREASURY}</li>
                <li>{VIEW_GLOBAL_MAP}</li>
            </ul>
        </div>
    ),
}



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Dialogs/ChangeRole/translations.js